<template>
	<section class="objeto">
		<Notification ref="notif" :closed="true" corner="bottom-right" />

		<div class="header">
			<div class="cover">
				<div class="like-button" @click="favourite()" :class="{ active: favourited }">
					<span class="far fa-heart"></span>
				</div>
				<div class="desc" v-if="objeto.tipoNome">
					<div><i :class="`${objeto.tipoIcone}`"></i></div>
					<div>{{objeto.tipoNome.toUpperCase()}}</div>
				</div>

				<!-- <video controls constrolsList="nodownload">
					<source src="https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_10mb.mp4" />
				</video> -->

				<!-- <iframe class="embedded-responsive" src="https://player.vimeo.com/video/314222133/?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=141351" allowfullscreen></iframe> -->

				<!-- <iframe width="1280" height="720" src="https://www.youtube.com/embed/dMp2BZ9QwgY" frameborder="0" allowfullscreen></iframe> -->
			</div>

			<div class="infos">
				<div class="titulo-voltar">
					<div class="titulo">
						<div>
							<span>Objeto educacional</span>
							<h2>{{ objeto.titulo }}</h2>
						</div>
					</div>
					<div class="box-voltar">
						<button class="voltar"  @click="$router.go(-1)"><i class="far fa-arrow-alt-circle-left"></i><span class="text">voltar </span></button>
					</div>
				</div>

				<div class="actions">

					<div class="controls">
						<a class="btn" target="_blank" :href="`${objeto.urlObjeto}`">
							<i class="fas fa-eye" />VISUALIZAR</a>
						<!-- </a>
						<a v-else class="btn" @click="Visualizar"><i class="fas fa-eye" />VISUALIZAR</a>-->
						<a class="btn" @click="Cadastro">
							<span class="material-icons">playlist_add</span>
							SALVAR NA COLEÇÃO
						</a>
					</div>
				</div>

				<div class="details">
					<div class="row">
						<div class="curadoria">Curadoria: {{ objeto.curadoriaNome }}</div>
						<div class="subCuradoria">Sub-Curadoria: {{ objeto.subCuradoriaNome}} </div>
						<div class="Eixo">Eixo: {{objeto.eixoNome}}</div>
					</div>
					<div class="row">
						<div class="disRecorrentes" v-if="objeto.disciplinasNomes">Disciplinas recorrentes: {{ objeto.disciplinasNomes }} </div>
						<div class="tagsGerais" v-if="objeto.tagsNomes">Tags gerais: {{objeto.tagsNomes}} </div>
					</div>
					<div class="row" v-if="objeto.cursosNomes">
						<div class="curRecorrentes">Cursos recorrentes: {{ objeto.cursosNomes }}</div>
					</div>
				</div>

				<!-- <div class="statistics">
					<p><i class="fas fa-eye" /> {{ objeto.qtdDeAcessos || 0}} Views</p>
					<p><i class="fas fa-heart" />{{ objeto.likes || 0 }} Likes</p>
					<p><i class="fas fa-download" /> {{ objeto.qtdDeDownloads || 0 }} Downloads</p>
				</div> -->

				<!--<div class="tags">
					<div class="title">
						<h3>Tags</h3>
						<div class="line"></div>
					</div>
					<div class="container-tags">
						<span class="tag" v-for="(tag, index) in objeto.tags" :key="index">{{ tag }}</span>
					</div>
				</div>-->
			</div>
		</div>

		<div class="messages">
			<Notification :closed="true" />
		</div>

		<tabs :objeto="objeto" :tabs="tabs" />

		<!-- <div class="related-objects">
			<h3>OBJETOS RELACIONADOS</h3>

			<div class="related-objects-container">
				<div class="related" v-for="related in objetosRelacionados" :key="related.id">
					<div class="cover">
						<img :src="related.imagemCapa" :alt="related.nome" />
					</div>

					<div class="details">
						<p>{{ related.nome }}</p>

						<router-link :to="{ name: 'objeto', params: { id: related.id }}">ACESSAR</router-link>
					</div>

				</div>
			</div>
		</div> -->

		<SalvarNaColecao @boxCreate="createCollection" :boxCadastro="boxCadastro" :objetoId="$route.params.id" v-if="boxCadastro" />
		<ContentPreview v-if="showPreview" @closePreview="closePreview" @downloadFile="BaixarArquivo" :object="objeto" />

	</section>
</template>

<script>
import { objetos } from '@/services/objetos'
import { usuarios } from '@/services/usuarios'
import Tabs from './Tabs'
import EventBus from './../../event-bus'
import SalvarNaColecao from './SalvarNaColecao'
import ContentPreview from './inc/ContentPreview'

export default {
	name: 'Objeto',
	components: { SalvarNaColecao, Tabs, ContentPreview },
	data () {
		return {
			objeto: {},
			objetosRelacionados: [],
			path: '',
			boxCadastro: false,
			favourited: false,
			requestStatus: false,
			showPreview: false,
			allowedExtensionsPreview: ['.doc', '.docx', '.odt', '.ppt', '.pptx', '.xls', '.xlsx'],
			modulos: {},
			icon: {},
			tabs: []
		}
	},

	watch: {
		'$route.params.id': function () {
			this.findById()
			this.favourited = false
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = from.fullPath
		})
	},
	methods: {
		Cadastro () {
			this.boxCadastro = !this.boxCadastro
		},
		Visualizar () {
			// const extension = this.objeto.urlObjeto.replace(/^(.{0,})(\.[a-z0-9]{2,4})(.{0,})$/, '$2')

			if (this.objeto.tipoNome === 'Documentos') {
				this.showPreview = true
			}
			// // if (this.objeto.link && (this.objeto.link.match(/iframe/) || this.objeto.tipoNome === 'Vídeos' || this.objeto.arquivoZipLivro !== null || ((this.objeto.tipoNome === 'Documentos' || this.objeto.tipoNome === 'Livro') && this.allowedExtensionsPreview.indexOf(extension) !== -1))) {
			// if ((this.objeto.urlObjeto && this.objeto.urlObjeto.match(/iframe/)) || this.objeto.tipoNome === 'Vídeos' ||
			// 	this.objeto.tipoNome === 'Temas' ||
			// 	(this.objeto.tipoNome && this.allowedExtensionsPreview.indexOf(extension) !== -1) || this.objeto.tipoNome === 'Podcasts') {
			// 	this.showPreview = true
			// } else {
			// 	this.BaixarArquivo()
			// }
		},
		// BaixarArquivo () {
		// 	objetos.countStocks({ id: this.$route.params.id, acao: 'downloads' })
		// 	if (this.objeto.link) {
		// 		window.open(this.objeto.link)
		// 	} else {
		// 		window.open(this.objeto.url)
		// 	}
		// },
		createCollection (boxCreate) {
			this.boxCadastro = boxCreate
		},
		async findById (id = this.$route.params.id) {
			const loadContent = false
			EventBus.$emit('closeLoader', loadContent)
			await objetos.findById(id)
				.then(res => {
					this.objeto = { ...res.data, tags: !res.data.tags || res.data.tags === '' ? [] : res.data.tags.split(',') }
					// this.modulos = res.data.
					const favourites = usuarios.objetosFavoritos(this.$auth.user().id, '', '', res.data.tipoId)
					// const related = objetos.relatedObjects(id)
					const tipoEntradas = []
					this.objeto.propriedadesTiposEntrada !== null && this.objeto.propriedadesTiposEntrada.split(';').map((tipo, index) => {
						if (tipo === 'textarea' || tipo === 'text') {
							tipoEntradas.push({
								indice: index,
								tipo: tipo,
								texto: this.objeto.propriedadesValores !== null && this.objeto.propriedadesValores.split(';')[index],
								nome: this.objeto.propriedadesNomes !== null && this.objeto.propriedadesNomes.split(';')[index]
							})
						}
					})
					this.tabs = tipoEntradas

					if (this.objeto.idPreRequisito) {
						window.notificationEM.open('Este objeto possui uma dependência associada', `<a href='/objeto/${this.objeto.idPreRequisito}')>${this.objeto.tituloPreRequisito}</a>`, 'warning')
					}

					Promise.all([favourites])
						.then(res => {
							// this.objetosRelacionados = res[1].data
							res[0].data = res[0].data.filter(el => el.id === this.objeto.id)
							this.favourited = res[0].data.length > 0
						})
						.catch(err => console.log(err))
				})
				.catch(err => console.log(err))
		},
		async favourite () {
			// Desabilita novas requisições, caso a anterior não tenha sido concluída
			if (this.requestStatus) {
				return
			}

			// Altera o status da requisição para evitar acúmulo de requisições repetidas
			this.requestStatus = true

			if (this.favourited) {
				usuarios.desvincularFavoritos(this.$auth.user().id, this.objeto.id).then(data => {
					this.requestStatus = false
					this.favourited = false
				}).catch(data => {
					this.requestStatus = false
				})
			} else {
				usuarios.vincularFavoritos(this.$auth.user().id, this.objeto.id).then(data => {
					this.requestStatus = false
					this.favourited = true
				}).catch(data => {
					this.requestStatus = false
				})
			}
		},
		async countStocks () {
			await objetos.countStocks({ id: this.$route.params.id, acao: 'acessos' })
		},
		closePreview () {
			this.showPreview = !this.showPreview
		}
	},
	created () {
		// this.countStocks()
		this.findById()
	}
}
</script>

<style lang="scss" scoped>
.objeto {
	width: 100%;

	.header {
		display: grid;
		grid-template-columns: 550px;
		grid-gap: 0px 0px;

		.cover {
			position: relative;
			grid-row: 1;
			background-image: url('../../../assets/images/bg1_detalhes.png');
			background-repeat: no-repeat;
			height: 312px;
			width: 521px;
			background-size: 100% 100%;

			.like-button {
				position: absolute;
				top: 26px;
				left: 27px;
				width: 70px;
				height: 70px;
				border-radius: 15px;
				// : linear-gradient(0deg, #091B37 70px, #3337 70px, #3332 77px, transparent);
				background: #091B37 0% 0% no-repeat padding-box;
				opacity: 1;
				border-radius: 50%;
				color: #00243E;
				// color: #FFF;
				cursor: pointer;

				span {
					position: absolute;
					top: 22.5%;
					left: 20.5%;
					font-size: 40px;
					color: #fff;
				}
			}

			.desc {
					display: flex;
					flex-direction: column;
					margin-right: 96px;
					justify-content: center;
					align-items: center;
					width: 100%;
					height: auto;
					padding-top: 62px;
					padding-bottom: 62px;
					color: #fff;
					border-radius: 5px;
					padding-left: 10px;
					padding-right: 10px;

					i {
						font-size: 110px;
					}
					div {
						font: Condensed Bold 50px/50px Roboto;
						text-align: center;
					}
			}

			.like-button:not(:active) {
				&:hover span {
					font-weight: 510 !important;
				}
			}

			.like-button.active {
				span {
					font-weight: 510 !important;
				}

				&:hover span {
					font-weight: 400 !important;
				}
			}

			img {
				border-radius: 15px;
				width: 100%;

				&:not([src=""]) {
					width: 100%;
					height: 100%;
					background-color:#FFF;

					& + span.whitout-image {
						display: block;
						position: absolute;
						top: 47%;
						left: 30%;
						font-family: 'Roboto Condensed', 'Roboto', sans-serif;
						font-weight: bold;
						font-size: 50px;
						text-transform: uppercase;
						color: #0002;
					}
				}
			}

			span.whitout-image {
				display: none;
			}
		}

		.infos {
			grid-row: 1;

			.titulo-voltar {
				display: grid;
				grid-template-columns: auto 100px;
				grid-gap: 0 40px;

				.titulo {
					display: flex;
					align-items: center;

					div {

						span {
							color: $grey-color;
							font-size: 1.2em;
						}

						h2 {
							color: #fff;
							font-size: 1.5em;
							font-weight: 700;
							text-transform: uppercase;
						}
					}

					.icone {
						i {
							font-size: 4em;
							color: $grey-color;
						}
					}
				}

				.box-voltar {
					display: flex;
					align-items: flex-end;
					justify-content: flex-end;

					.voltar {
						display: flex;
						align-items: center;
						background-color:#59708F;
						padding: 9px 13px 10px;
						border: none;
						color: #FFF;
						font-size: 26px;
						border-radius: 5px;
						margin-right: 10px;
						font-family: Roboto;
						max-width: 50px;
						min-width: 50px;
						cursor: pointer;
						transition: 0.666s max-width ease;

						.text {
							display: inline-block;
							transform: scaleX(0);
							transition: 0.444s transform ease;
							transform-origin: left center;
							margin-left: 5px;
							padding-right: 5px;
						}
					}
					.voltar:hover{
						background-color:#ffffff;
						color: #59708F;
						max-width: 200px;
						height: 50px;
						.text {
							transform: scaleX(1);
							font-size: 16px;
						}
					}
				}
			}

			.actions {
				margin: 20px 0;
				display: grid;
				grid-template-columns: auto auto;
				grid-gap: 0 40px 0;
				color: #fff;

				.tipo {
					p {
						strong {
							font-weight: 700;
						}
					}
				}

				.controls {
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					a {
						text-decoration: none;
						color: #fff;
						background-color: #59708F;
						margin-bottom: 10px;
					}

					.btn {
						height: 50px;
						color: #fff;
						border: none;
						border-radius: 5px;
						padding: 0 16px;
						font-weight: 700;
						font-size: 1em;
						cursor: pointer;
						outline: none;
						display: flex;
						align-items: center;
						justify-content: center;

						i {
							font-size: 1.2em;
							margin-right: 10px;
						}

						& {
							margin-right: 10px;
							background-color: $second-color;
						}

						&:last-child {
							background-color: $yellow-color;
							color: $main-color;
						}
					}
				}
			}

			// .statistics {
			// 	display: grid;
			// 	grid-template-columns: auto auto auto;
			// 	grid-gap: 0 20px;
			// 	color: $grey-color;
			// 	font-weight: 700;
			// 	font-size: 1.2em;

			// 	p {
			// 		&:nth-of-type(2) {
			// 			text-align: center;
			// 		}

			// 		&:last-of-type {
			// 			text-align: right;
			// 		}

			// 		i {
			// 			margin-right: 6px;
			// 		}
			// 	}
			// }

			.details {
				font: Condensed 12px/26px Roboto;
				color: #ffffff;
				.row {
					display: flex;
					flex-wrap: wrap;
					margin-bottom: 8px;
					div {
						min-width: 102px;
						height: 32px;
						background: #1B2E46 0% 0% no-repeat padding-box;
						border: 1px dashed #FFFFFF;
						border-radius: 5px;
						opacity: 1;
						display: flex;
						margin-right: 9px;
						padding-left: 5px;
						padding-right: 5px;
						align-items: center;
					}
				}
			}

			.tags {
				color: #fff;

				.title {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin: 60px 0 16px;

					h3 {
						font-size: 1.5em;
					}

					.line {
						height: 1px;
						width: 100%;
						background-color: #fff;
						margin-left: 16px;
					}
				}

				.container-tags {
					display: flex;
					flex-wrap: wrap;

					span {
						display: block;
						margin: 10px 10px 0 0;
						border: 2px solid $grey-color;
						background-color: #101924;
						text-transform: uppercase;
						padding: 6px 20px;
						border-radius: 20px;
						font-size: .8em;

						&:not(:first-of-type) {
							margin-right: 10px;
						}
					}
				}
			}
		}

	}

	.messages {
		margin: 20px auto;
	}

	.related-objects {
		h3 {
			color: #fff;
			font-weight: 700;
			font-size: 1.5em;
		}

		.related-objects-container {
			display: grid;
			grid-template-columns: repeat(5, 1fr);
			grid-gap: 0 40px;
			padding: 30px 0 0;
			font-size: 14px;
			line-height: 22px;

			.related {
				background-color: #fff;
				display: flex;
				flex-direction: column;
				border-radius: 6px 6px 5px 5px;

				.cover {
					position: relative;
					border-radius: 5px 5px 0 0;

					img {
						width: 100%;
						border-radius: 5px 5px 0 0;

						&:not([src]) {
							width: 100%;
							height: 80px;
							background-color: #FFF;
						}
					}
				}

				.details {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: space-between;
					width: 100%;
					height: 100%;
					padding: 10px 8px;
					text-align: center;

					p {
						color: #707070;
					}

					a {
						background-color: $main-color;
						color: #fff;
						width: 100%;
						text-decoration: none;
						margin: 20px 0 0;
						padding: 6px 0;
						border-radius: 10px;
						font-weight: 700;
						font-size: .9em;
					}
				}
			}
		}
	}
}
.embedded-responsive {
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 0;
	border-radius: 10px;
	background-color: #000;
}

@media screen and (max-width: 700px) {
	.objeto {
		width: 300px;
		.header {
			display: grid;
			flex-direction: column;
			grid-template-columns: 1fr;
			width: 300px;
			.cover {
				background-size: 100% 80%;
				width: 320px;
				.like-button {
					top: 15px;
					left: 12px
				}
				.desc {
					// width: 50%;
					i {
						font-size: 70px;
					}
					div {
						font-size: 30px;
					}
				}
			}
			.infos {
				grid-row: auto;
			}
		}
	}
}

@media screen and (min-width: 700px) and (max-width: 1025px) {
	.objeto {
		// width: 300px;
		.header {
			// display: grid;
			// flex-direction: column;
			// width: 300px;
			grid-template-columns: 1fr;
			.cover {
				background-size: 100% 100%;
				height: 450px;
				width: 100%;
				.like-button {
					top: 15px;
					left: 12px;
				}
				.desc {
					padding-top: 137px;
					i {
						font-size: 70px;
					}
				}
			}
			.infos {
				grid-row: auto;
			}
		}
	}
}
</style>
